import faker from 'faker'

export const mocker = {
  knowledge () {
    let mockKnowledges = []
    const knowledgeAmount = 10
    for (var i = 0; i < knowledgeAmount; i++) {
      mockKnowledges.push({
        title: faker.lorem.words(),
        content: faker.lorem.paragraph(),
        file_name: faker.lorem.word(),
        file_path: faker.image.avatar(),
        link: faker.internet.url(),
        date: faker.date.past().toString().substr(4, 12),
        coduser: faker.random.number(),
        dteupd: faker.date.past().toString().substr(4, 12)
      })
    }
    return {
      total: knowledgeAmount,
      rows: mockKnowledges
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/knowledge/mocker.js